/**
 * SNN — Solar News Network. A flavor ticker that scrolls procedurally
 * generated dispatches in the right-rail on desktop. Pure DOM so text
 * stays razor-sharp.
 */

const HEADLINES: readonly string[] = [
  'TERAFAB SECTOR 7-G BRINGS 1.2 EXAFLOPS ONLINE',
  'VOID SEED CLUSTER DETECTED NEAR KUIPER PICKET',
  'STARSHIP S48 COMPLETES 412TH ORBITAL REFUEL',
  'COMMANDER LEADERBOARD RECALCULATED — ASIA RELAY WINS WEEK',
  'NEURAL SPIKE YIELD UP 8% AFTER COMPILER PATCH 2026.4',
  'ALIEN VOID INDEX TICKS TO 0.37 — WITHIN NOMINAL RANGE',
  'DRY DOCK MUSK-9 BEGINS ASSEMBLY OF CARRIER-CLASS STARFARER',
  'COMPUTE DERIVATIVES MARKET OPENS AT 0800 UTC',
  'SNN BRIEFING: ORBITAL LAW 12.7 AMENDS VOID BOUNTY SCHEDULE',
  'TERAFAB FOUNDRIES ANNOUNCE COMPUTE-BACKED COMMANDER BONDS',
];

export function mountSnnTicker(): void {
  const track = document.querySelector<HTMLElement>('.snn__track');
  if (!track) return;
  // Duplicate items twice so the CSS-driven scroll wraps without a visible gap.
  const content = HEADLINES.map((h) => `<span>${h}</span>`).join('');
  track.innerHTML = content + content;
}
